import {
  Card,
  Checkbox,
  Col,
  Form,
  Input,
  message,
  Modal,
  Row,
  Select,
  Table,
  Typography,
} from "antd";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import {
  LeftOutlined,    // LeftOutlined
  EditOutlined,    // EditOutlined
  DeleteOutlined,  // DeleteOutlined
  PlusOutlined,    // PlusOutlined
  SettingOutlined  // SettingOutlined
} from '@ant-design/icons';
import AlertPopup from "@/components/AlertPopup";
import SortableSelect from "@/components/SortableSelect";
import Dropdown from "@/components/Dropdown";
import Dropdown1 from "@/components/Dropdown1";
import instance, { apiUrl } from "@/services/axios.config";
import eventService from "@/services/event.service";
import InspectionBtn from "@/components/InspectionBtn";

const EventManagement = () => {
  const { control, handleSubmit, getValues, setValue, reset } = useForm({});
  const [eventVal, setEventVal] = useState([]);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [allevents, setAllEvents] = useState([]);
  const [addEvents, setAddEvent] = useState(false);
  const [eventid, setEventid] = useState("");
  const [moduleinfo, setModuleInfo] = useState([]);
  const [updateEvent, setUpdateEvent] = useState(false);
  const columns = [
    {
      title: "Event Type",
      dataIndex: "event_type",
      key: "event_type",
    },
    {
      title: "Naming",
      dataIndex: "naming",
      key: "naming",
    },
    {
      title: "Modules",
      dataIndex: "modules",
      key: "modules",
      render: (data) =>
        data?.split(",")?.map((x) => (
          <span
            className="badge ms-2 mb-2 text-bg-success"
            style={{ fontSize: "14px" }}
          >
            {" "}
            {x}
          </span>
        )),
    },

    {
      title: "isActive",
      dataIndex: "isActive",
      key: "isActive",
    },
    {
      title: "Action",
      key: "operation",
      render: (data) => (
        <div className="d-flex justify-content-center gap-3">
          <EditOutlined
            onClick={() => {
              setEventData(data);
            }}
            size={20}
          />
          <DeleteOutlined
            className=" ms-5 text-danger"
            onClick={() => {
              handleDelete(data);
            }}
            size={20}
          />
        </div>
      ),
    },
  ];

  const handleDelete = (data) => {
    setEventid(data?.key);
    setShowDeleteConfirm(true);
  };

  const handleConfirm = async () => {
    await eventService.deleteEventType(eventid);
    setEventid("");
    setShowDeleteConfirm(false);
  };

  const handleCancel = () => {
    setShowDeleteConfirm(false);
  };

  const setEventData = (data) => {
    setAddEvent(true);
    setEventid(data?.key);

    const modules = data?.modules?.split(",")?.map((x) => {
      return { label: x, value: x };
    });
    setValue("event_type", data?.event_type);
    setValue("modules", modules);
    setValue("naming", data?.naming || null)
    setValue("isActive", data?.isActive === "Active" ? true : false);
  };
  const onSubmit = async (data) => {

    data.modules = data.modules?.map((x) => x?.label)?.toString();
    try {
      if (eventid) {
        const payload = {
          id: eventid,
          event_type: data?.event_type,
          isActive: data?.isActive ? 1 : 0,
          modules: data?.modules,
          naming: data?.naming || null
        };
        const response = await eventService.updateEventType(payload);
        if (response) {
          message.success("Event Updated Successfully");
          setAddEvent(false);
          reset();
        }
      } else {
        const payload = {
          event_type: data?.event_type,
          isActive: data?.isActive ? 1 : 0,
          modules: data?.modules,
          naming: data?.naming || null

        };

        const response = await eventService.addEventType(payload);
        if (response) {
          message.success("Event Added Successfully");
          setAddEvent(false);
          reset();
        }
      }
    } catch (error) {
      console.error("Error adding event:", error);
    }
    setEventid("");
  };

  const getallEvents = async () => {
    const { data } = await eventService.getAllEvents();
    const eventsdetails = data?.map((x) => {
      return {
        label: x?.event_type,
        value: x?.event_type,
      };
    });
    setAllEvents(eventsdetails);
    if (data) {
      const eventlist = data?.map((x) => {
        return {
          key: x?.id,
          event_type: x?.event_type,
          isActive: x?.isActive ? "Active" : "InActive",
          modules: x?.modules,
          benchmark: x?.benchmark,
          naming: x?.naming || null

        };
      });
      setEventVal(eventlist);
    }
  };
  useEffect(() => {
    getallEvents();
  }, [addEvents, eventid]);

  const viewModulehandler = async () => {
    const res = await eventService.getallModules();
    if (res) {

      const modules = res?.data?.map((x) => {
        return {
          label: x?.tableName,
          value: x?.tableName,
        };
      });
      setModuleInfo(modules);
    }
  };
  useEffect(() => {
    viewModulehandler();
  }, []);

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-4">
        <Typography.Title level={5} className=" font-bold">Event Management</Typography.Title>
        <InspectionBtn
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => {
            setAddEvent(true);
            reset();
          }}
          className="bg-green-600"
        >
          Event Manager
        </InspectionBtn>
      </div>

      {addEvents ? (
        <Form onFinish={handleSubmit(onSubmit)}>
          <Row gutter={24}>
            <Col md={3}>
              <p className="mb-2">Events Name</p>
              <Form.Item>
                <Controller
                  control={control}
                  name={`event_type`}
                  rules={{
                    required: "Required",
                  }}
                  render={({ field }) => <Input {...field} />}
                />
              </Form.Item>
            </Col>


            <Col md={9}>
              <p className="mb-2">Modules</p>
              <SortableSelect
                control={control}
                name={`modules`}
                getValues={getValues}
                setValue={setValue}
                options={moduleinfo}
              />
            </Col>
            <Col md={5}>
              <p className="mb-2">Naming</p>
              <Controller
                control={control}
                name={`naming`}
                rules={{
                  required: "Required",
                }}
                render={({ field }) => <Input {...field} />}
              />
            </Col>
            <Col md={4}>
              <Form.Item className="mb-2">
                <Controller
                  control={control}
                  name={`isActive`}
                  render={({ field }) => (
                    <Checkbox {...field} checked={field?.value}>
                      is Active
                    </Checkbox>
                  )}
                />
              </Form.Item>
            </Col>

          </Row>


          <InspectionBtn htmlType="submit" type="primary">
            Save Event
          </InspectionBtn>
        </Form>
      ) : (

        <Table
          className="spotflash-table" dataSource={eventVal}
          columns={columns}
          size={"small"}
          pagination={false}
        />
      )}

      <AlertPopup
        show={showDeleteConfirm}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
    </div>
  );
};

export default EventManagement;
